import { ListChecks, User, Settings, Check } from "lucide-react";

interface WizardStepperProps {
  currentStep: 1 | 2 | 3;
}

const steps = [
  { label: "Items", icon: ListChecks },
  { label: "Name", icon: User },
  { label: "Settings", icon: Settings },
] as const;

export default function WizardStepper({ currentStep }: WizardStepperProps) {
  return (
    <div className="flex items-center justify-center gap-0">
      {steps.map((step, i) => {
        const stepNum = (i + 1) as 1 | 2 | 3;
        const isActive = stepNum === currentStep;
        const isCompleted = stepNum < currentStep;
        const Icon = step.icon;

        return (
          <div key={step.label} className="flex items-center">
            {i > 0 && (
              <div
                className={`h-0.5 w-8 sm:w-12 ${
                  isCompleted || isActive
                    ? "bg-primary"
                    : "bg-border"
                }`}
              />
            )}
            <div className="flex flex-col items-center gap-1">
              <div
                className={`flex h-9 w-9 items-center justify-center rounded-full transition-colors ${
                  isCompleted
                    ? "bg-accent text-white"
                    : isActive
                      ? "bg-primary text-text-inverse"
                      : "bg-surface-sunken text-text-secondary"
                }`}
              >
                {isCompleted ? (
                  <Check className="h-4 w-4" />
                ) : (
                  <Icon className="h-4 w-4" />
                )}
              </div>
              <span
                className={`text-xs font-medium ${
                  isActive
                    ? "text-primary"
                    : isCompleted
                      ? "text-accent"
                      : "text-text-secondary"
                }`}
              >
                {step.label}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
